import React from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import { FiGlobe } from 'react-icons/fi';
import { useAppearance } from '../theme/AppearanceProvider';

// item 1449 (Chad: "the Shared To Portal is throwing me off… there's got to be something cool that
// could be really clear to Tom and me that this ledger entry is in the client's portal, but not
// necessarily this eyesore") — the SHARED TO PORTAL badge, as a small glyph that sits right after
// the document number: a purple globe in a soft ring (a faint glow on the Aurora skin). One glance
// says "the client can see this"; hover says exactly what they see. Replaces the item-997 chip on
// the ledgers (the contracts cards keep the long form).
const PortalMark: React.FC<{ what: string }> = ({ what }) => {
  const { aurora } = useAppearance();
  return (
    <Tooltip label={`In the client's portal — they can see ${what}.`} placement="top" hasArrow openDelay={0}>
      <Box
        as="span"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        w="16px"
        h="16px"
        borderRadius="full"
        bg="purple.500"
        color="white"
        fontSize="10px"
        verticalAlign="middle"
        boxShadow={aurora ? '0 0 8px rgba(159, 122, 234, 0.7)' : 'none'}
        flexShrink={0}
        aria-label="In the client's portal"
      >
        <FiGlobe />
      </Box>
    </Tooltip>
  );
};

export default PortalMark;
